import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { applyFieldFilter } from '../../../../shared/utils.js/fieldValidation';
import i18n from '../../../../i18n/i18n';
import { addEngineer } from '../../../../redux/Slices/EngineersSlice';

// add engineer component
const AddEngineer = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const isRTL = i18n.language === 'ar';
  const [form, setForm] = useState({
    name_ar: '',
    name_en: '',
    tax_number: '',
    address: '',
    phone: '',
    email: '',
    is_active: true,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const finalValue = type === 'checkbox' ? checked : applyFieldFilter(name, value);
    setForm((prev) => ({ ...prev, [name]: finalValue }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name_ar || !form.name_en) {
      toast.error(t('engineers.add.messages.nameRequired'), { rtl: isRTL });
      return;
    }
    try {
      setIsSubmitting(true);
      await dispatch(addEngineer(form)).unwrap();
      toast.success(t('engineers.add.messages.addSuccess'), { rtl: isRTL });
      navigate('/engineers');
    } catch (error) {
      toast.error(error || t('engineers.add.messages.addError'), { rtl: isRTL });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div style={{ ...pageStyle, direction: isRTL ? 'rtl' : 'ltr' }}>
      <div style={{ ...cardStyle, textAlign: isRTL ? 'right' : 'left' }}>
        <h2 style={{ marginBottom: 20, fontSize: '20px' }}>{t('engineers.add.title')}</h2>
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <div style={gridStyle}>
            {isRTL ? (
              <>
                <Input label={t('engineers.add.nameAr')} name="name_ar" value={form.name_ar} onChange={handleChange} required isRTL={true} />
                <Input label={t('engineers.add.nameEn')} name="name_en" value={form.name_en} onChange={handleChange} required isRTL={false} />
              </>
            ) : (
              <>
                <Input label={t('engineers.add.nameEn')} name="name_en" value={form.name_en} onChange={handleChange} required isRTL={false} />
                <Input label={t('engineers.add.nameAr')} name="name_ar" value={form.name_ar} onChange={handleChange} required isRTL={true} />
              </>
            )}
          </div>
          <div style={gridStyle}>
            <Input label={t('engineers.add.taxNumber')} name="tax_number" value={form.tax_number} onChange={handleChange} isRTL={isRTL} />
            <Input label={t('engineers.add.phone')} name="phone" value={form.phone} onChange={handleChange} isRTL={isRTL} />
          </div>
          <Input label={t('engineers.add.email')} name="email" value={form.email} onChange={handleChange} isRTL={false} />
          <Input label={t('engineers.add.address')} name="address" value={form.address} onChange={handleChange} isRTL={isRTL} />
          <label style={{ display: 'flex', alignItems: 'center', gap: 8, direction: isRTL ? 'rtl' : 'ltr' }}>
            <input type="checkbox" name="is_active" checked={form.is_active} onChange={handleChange} style={{ margin: isRTL ? '0 0 0 8px' : '0 8px 0 0' }} />
            {t('engineers.add.active')}
          </label>
          <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexDirection: isRTL ? 'row-reverse' : 'row' }}>
            <button type="submit" style={submitButtonStyle} disabled={isSubmitting}>
              {isSubmitting ? t('engineers.add.saving') : t('engineers.add.save')}
            </button>
            <button type="button" style={secondaryButtonStyle} onClick={() => navigate('/engineers')}>
              {t('engineers.add.cancel')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

const Input = ({ label, isRTL = true, ...rest }) => (
  <label style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
    <span style={{ fontSize: 14 }}>{label}</span>
    <input
      {...rest}
      style={{
        padding: 12,
        borderRadius: 8,
        border: '1px solid #333',
        backgroundColor: '#1a1f2e',
        color: 'white',
        direction: isRTL ? 'rtl' : 'ltr',
        textAlign: isRTL ? 'right' : 'left',
      }}
    />
  </label>
);

const pageStyle = {
  padding: 30,
  backgroundColor: '#14263b',
  minHeight: 'calc(100vh - 80px)',
  color: 'white',
  display: 'flex',
  justifyContent: 'center',
};

const cardStyle = {
  width: '100%',
  maxWidth: 700,
  backgroundColor: '#1b3350',
  borderRadius: 12,
  padding: 24,
  border: '1px solid #333',
};

const gridStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
  gap: 16,
};

const submitButtonStyle = {
  backgroundColor: '#AC2000',
  color: 'white',
  border: 'none',
  padding: '12px 18px',
  borderRadius: 8,
  cursor: 'pointer',
  minWidth: 120,
};

const secondaryButtonStyle = {
  backgroundColor: 'transparent',
  color: 'white',
  border: '1px solid #444',
  padding: '12px 18px',
  borderRadius: 8,
  cursor: 'pointer',
  minWidth: 120,
};

export default AddEngineer;

